































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import type { HistoryRujukanItem, HistorySepItem, HistorySrkItem } from "@/types/bridging_bpjs";
import HistoryPeserta from "@/services/bridgingVclaim/HistoryPeserta";
import { isJsonStr } from "@/utility/CommonHelper";

@Component
export default class HistoryPesertaWidget extends Vue {
  noka = null;
  tab = "tab-sep";

  sepList: HistorySepItem[] = [];
  srkList: HistorySrkItem[] = [];
  rujukanList: HistoryRujukanItem[] = [];

  dataFromIframe = null;

  loadingSepList = false;
  loadingSrkList = false;
  loadingRujukanList = false;

  mounted() {
    window.addEventListener("message", this.listenIframeParentEvent);
  }


  getHistory() {
    this.getSepList();
    this.getSrkList();
    this.getRujukanList();
  }

  async getSepList() {
    this.loadingSepList = true;
    const resp = await HistoryPeserta.getHistorySep(this.noka).finally(() => {
      this.loadingSepList = false;
    })

    this.sepList = resp.data;
  }

  async getSrkList() {
    this.loadingSrkList = true;
    const resp = await HistoryPeserta.getHistorySrk(this.noka).finally(() => {
      this.loadingSrkList = false;
    })

    this.srkList = resp.data;
  }

  async getRujukanList() {
    this.loadingRujukanList = true;
    const resp = await HistoryPeserta.getHistoryRujukan(this.noka).finally(() => {
      this.loadingRujukanList = false;
    })

    this.rujukanList = resp.data;
  }

  listenIframeParentEvent(ev) {
    console.log('listen iframe parent event', ev.origin)
    if (["http://10.10.187.6", "http://10.10.187.37"].includes(ev.origin))
      return false;

    const data = isJsonStr(ev.data) ? JSON.parse(ev.data) : null;

    this.dataFromIframe = data;
  }

  clearAll() {
    this.sepList = [];
    this.srkList = [];
    this.rujukanList = [];
  }

  @Watch("dataFromIframe")
  changeDataFromIframe(
    val: null | {
      event: string;
      data?: null | {
        noKartu?: string;
      };
    }
  ) {
    if (val) {
      if (val.event === "GET_NOKA_DATA") {
        this.noka = val.data.noKartu;

        this.$nextTick(() => {
          this.getHistory();
        })
      }

      if (val.event === 'CLEAR_NOKA_DATA') {
        this.noka = null;
        this.sepList = null;
        this.rujukanList = null;
        this.srkList = null;
      }

      this.dataFromIframe = null;
    }
  }

  @Watch('noka')
  changeNoka(val) {
    if (!val || val.length < 13) {
      this.clearAll()
    }
  }
}
